module.exports = __webpack_public_path__ + "static/media/5DPO3.b26b4aa0.jpg";